module.exports = {
    UNSUPPORTED: /Mobile|webOS|iPod|Kindle|BlackBerry|PalmOS|PalmSource|Opera Mini|IEMobile|SonyEricsson|smartphone/i,
    SUPPORTED: /Android|iPhone|iPad/i
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_useragent.js